import React, { useEffect, useState } from "react";
import { Upload, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageContainer, PageHeader, EmptyState } from "@/components/Page";

const MediaLibrary = () => {
  const [data, setData] = useState({ items: [], used_mb: 0, limit_mb: 5000 });
  const [filter, setFilter] = useState("All");

  const load = () => api.get("/media").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const addMock = async () => {
    const samples = [
      { name: "marketing-video-clip.mp4", type: "video", url: "https://images.unsplash.com/photo-1638494004309-3aed351a0874?w=400", size_mb: 12.4 },
      { name: "brand-photo.jpg", type: "image", url: "https://images.unsplash.com/photo-1645848810565-ff3c1de0da09?w=400", size_mb: 1.2 },
      { name: "campaign-thumbnail.jpg", type: "image", url: "https://images.pexels.com/photos/14540962/pexels-photo-14540962.jpeg?w=400", size_mb: 2.1 },
    ];
    const pick = samples[Math.floor(Math.random() * samples.length)];
    await api.post("/media/upload-mock", pick);
    toast.success("Asset uploaded");
    load();
  };

  const filtered = data.items.filter((i) => filter === "All" || (filter === "Images" ? i.type === "image" : i.type === "video"));

  return (
    <PageContainer>
      <PageHeader title="Media Library" subtitle="All your brand assets, in one place." testId="media-header" actions={
        <span className="px-3 py-1.5 bg-purple-50 text-[#7C3AED] rounded-full text-xs font-semibold border border-purple-100" data-testid="storage-badge">
          Storage: {data.used_mb} MB / {data.limit_mb} MB
        </span>
      } />
      <div className="flex items-center justify-between mb-6">
        <div className="flex gap-2">
          {["All", "Images", "Videos"].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={filter === f ? "op-pill-active" : "op-pill-inactive"} data-testid={`media-filter-${f.toLowerCase()}`}>{f}</button>
          ))}
        </div>
        <button onClick={addMock} className="op-btn-primary" data-testid="media-upload"><Upload size={16} /> Upload</button>
      </div>
      {filtered.length === 0 ? (
        <div className="op-card"><EmptyState icon={ImageIcon} title="No assets yet" description="Upload images and videos to use across campaigns." action={<button onClick={addMock} className="op-btn-primary">Upload →</button>} /></div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {filtered.map((m) => (
            <div key={m.id} className="op-card overflow-hidden">
              <div className="aspect-square bg-gray-100"><img src={m.url} alt="" className="w-full h-full object-cover" /></div>
              <div className="p-2">
                <p className="text-xs font-medium truncate">{m.name}</p>
                <span className="text-[10px] uppercase font-semibold text-[#7C3AED]">{m.type}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </PageContainer>
  );
};
export default MediaLibrary;
